import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import ListBlock from 'src/components/molecules/list/ListBlock';
import Heading from 'src/components/atoms/typo/Heading';
import { DefaultPageProps as Props } from 'src/constants/Interface';

class AdminTopPage extends Component<Props> {
  constructor(props: any) {
    super(props);
    this.transferShopList.bind(this);
  }

  transferShopList = () => {
    this.props.pushUrl('/admin/shop');
  };

  render() {
    return (
      <DefaultLayout {...this.props}>
        <Block>
          <Heading text={'Admin'} />
          <ListBlock
            clickEvent={this.transferShopList}
            listText={'店舗一覧を確認'}
            listColor={'primary'}
          />
        </Block>
      </DefaultLayout>
    );
  }
}

const Block = styled.div``;

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminTopPage);
